// extracted by mini-css-extract-plugin
module.exports = {"root":"Footer_root__2lgQY","inner":"Footer_inner__OykVg"};